const mainHeadings = [
  {
    heading: "Time for time oversigt",
    class: ["headings-base-style", "hide-on-smaller-than-6"],
  },
  {
    heading: "",
    class: ["main-heading-mobile-spacer", "hide-on-larger-than-6"],
  },
  {
    heading: "Varsel",
    class: [
      "x-small-main-heading",
      "headings-base-style",
      "hide-on-smaller-than-3",
    ],
  },
  {
    heading: "Maks/min temp",
    class: [
      "large-main-heading",
      "headings-base-style",
      "hide-on-smaller-than-4",
    ],
  },
  {
    heading: "Maks/min temp",
    class: [
      "hide-on-larger-than-4",
      "large-main-heading",
      "headings-base-style",
    ],
  },
  { heading: "Nedbør", class: ["small-main-heading", "headings-base-style"] },
  { heading: "Vind", class: ["small-main-heading", "headings-base-style"] },
  {
    heading: "UV maks",
    class: [
      "small-main-heading",
      "headings-base-style",
      "hide-on-smaller-than-4",
    ],
    info: "true",
  },
  {
    heading: "Luftfugtighed",
    class: [
      "small-main-heading",
      "headings-base-style",
      "hide-on-smaller-than-4",
    ],
  },
  {
    heading: "",
    class: [
      "large-main-heading",
      "headings-base-style",
      "hide-on-smaller-than-6",
    ],
  },
  {
    heading: "",
    class: ["main-heading-mobile-spacer", "hide-on-larger-than-6"],
  },
];

const hourHeadings = [
  {
    heading: "",
    class: [
      "small-hour-heading",
      "hour-headings-base-style",
      "hide-on-smaller-than-5",
      "sun-up-down-col",
    ],
  },
  {
    heading: "Tid",
    class: [
      "x-small-hour-heading",
      "hour-headings-base-style",
      "hide-on-larger-than-4",
    ],
  },
  {
    heading: "Tidspunkt",
    class: [
      "small-hour-heading",
      "hour-headings-base-style",
      "hide-on-smaller-than-4",
    ],
  },
  {
    heading: "Varsel",
    class: ["x-small-hour-heading", "hour-headings-base-style"],
  },
  {
    heading: "Temp",
    headingSub: "(Føles som)",
    class: [
      "large-hour-heading",
      "hour-headings-base-style",
      "hide-on-larger-than-5",
    ],
  },
  {
    heading: "Temp (Føles som)",
    class: [
      "large-hour-heading",
      "hour-headings-base-style",
      "hide-on-smaller-than-5",
    ],
  },
  {
    heading: "Nedbør",
    class: ["small-hour-heading", "hour-headings-base-style"],
  },
  {
    heading: "Vind m/s",
    headingSub: "(stød)",
    class: [
      "wind-hour-heading-mobile",
      "hour-headings-base-style",
      "hide-on-larger-than-4",
    ],
  },
  {
    heading: "Vind (Vindstød)",
    class: ["wind-hour-heading", "hide-on-smaller-than-4"],
  },
  {
    heading: "Luftfugtighed",
    class: [
      "small-hour-heading",
      "hour-headings-base-style",
      "hide-on-smaller-than-5",
    ],
  },
];

export { mainHeadings, hourHeadings };
